// apps/admin-ui/src/features/coin-transactions/schema.ts
import { CoinTxReasonSchema, CoinTxStatusSchema } from '@upme/contracts';
import { z } from 'zod';

// Search-params для /coin-transactions. Совмещает несколько источников:
// - cursor (server cursor pagination)
// - limit (server-side max 200, default 50)
// - status / reason — multi-select; URL хранит массивы. Принимаем строку
//   (CSV или одиночное значение, например ?status=PENDING) или массив (для
//   совместимости с навигацией через router.navigate({ search: { status: [...] } })).
// - userId — uuid фильтр.
//
// Все ключи опциональны. Если массив status/reason содержит хотя бы одно
// неизвестное значение — pipe в enum-array фейлится целиком; внешний catch
// в validateSearch (route.tsx) сбрасывает search до дефолтов. Поведение
// безопасное, но фильтры не «частично» применятся при битом URL.

const toArrayOfStatuses = z
  .union([z.string(), z.array(z.string())])
  .transform((v) => (Array.isArray(v) ? v : v.split(',')))
  .transform((arr) => arr.map((s) => s.trim()).filter(Boolean))
  .pipe(z.array(CoinTxStatusSchema))
  .optional();

const toArrayOfReasons = z
  .union([z.string(), z.array(z.string())])
  .transform((v) => (Array.isArray(v) ? v : v.split(',')))
  .transform((arr) => arr.map((s) => s.trim()).filter(Boolean))
  .pipe(z.array(CoinTxReasonSchema))
  .optional();

export const CoinTransactionsSearchSchema = z.object({
  cursor: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(200).default(50),
  status: toArrayOfStatuses,
  reason: toArrayOfReasons,
  userId: z.uuid().optional(),
});

export type CoinTransactionsSearch = z.infer<typeof CoinTransactionsSearchSchema>;
